import { httpClientOmni } from "@/libraries";

export default {
  async datatable(payload) {
    const response = await httpClientOmni.get(`reporting/v3/user-chat-session`, {
      params: payload,
    });
    return response;
  },

  async countReport(payload) {
    const response = await httpClientOmni.get(`reporting/v3/user-chat-session/count`, {
      params: payload,
    });
    return response;
  },

  async exportExcel(payload) {
    const response = await httpClientOmni.get(`reporting/v3/user-chat-session/export`, {
      params: payload,
    });
    return response;
  },
};
